// Compare Page
import CircleTick from "../../../compare/assets/icons/icon-tick-circle.svg";
import CompareAlert from "../../../compare/assets/icons/icon-alert-compare.svg";

// choose insurance
import ChooseHealth from "../../../compare/assets/icons/choose-product-health.svg";
import ChooseLife from "../../../compare/assets/icons/choose-product-life.svg";
import ChooseTrauma from "../../../compare/assets/icons/choose-product-trauma.svg";
import ChooseIncome from "../../../compare/assets/icons/choose-product-income.svg";
import ChooseMortgage from "../../../compare/assets/icons/choose-product-mortgage.svg";
import ChooseProductHelp from "../../../compare/assets/icons/choose-product-help.svg";
import ChooseCover from "../../../compare/assets/icons/choose-cover.svg";

// you and your family
import YouAndFamily from "../../../compare/assets/icons/icon-you-and-family.svg";
import AddAdult from "../../../compare/assets/icons/illustration-add-adult.svg";
import AddChildren from "../../../compare/assets/icons/illustration-add-children.svg";

import Callback from "../../../compare/assets/icons/icon-callback.svg";
import HelpPhone from "../../../compare/assets/icons/icon-phone-help.svg";
import ContactUs from "../../../compare/assets/icons/icon-contact-us-options.svg";
import Remove from "../../../compare/assets/icons/icon-remove.svg";
import Settings from "../../../compare/assets/icons/icon-settings.svg";
import Add from "../../../compare/assets/icons/icon-nav-add-product.svg";
import AlertInfo from "../../../compare/assets/icons/icon-info.svg";
import AlertPink from "../../../compare/assets/icons/icon-alert-pink.svg";
import AlertError from "../../../compare/assets/icons/icon-alert-red.svg";
import Help from "../../../compare/assets/icons/icon-help-tooltip.svg";

import AiaVitality from "../../../compare/assets/icons/logo-aia-vitality.svg";
import GreenTick from "../../../compare/assets/icons/icon-green-tick.svg";
import WhiteTick from "../../../compare/assets/icons/icon-tick-white.svg";
import GreenCircle from "../../../compare/assets/icons/icon-done-tick.svg";
import RedCross from "../../../compare/assets/icons/icon-red-x.svg";
import GreyCross from "../../../compare/assets/icons/icon-grey-x.svg";
import PolicyPlaceholder from "../../../compare/assets/icons/compare-with-bank-policy.svg";
import GreenTickNew from "../../../compare/assets/icons/icon-tick.svg";
import Pencil from "../../../../../images/svg/icons/icon-grey-pencil.svg";

import Calculator from "../../../compare/assets/icons/icon-calculator-green.svg";
import ArrowAccordion from "../../../compare/assets/icons/icon-arrow-accordion.svg";
import AccordionPlus from "../../../compare/assets/icons/icon-accordion-plus.svg";
import AccordionMinus from "../../../compare/assets/icons/icon-accordion-minus.svg";

// sidebar
import Overview from "../../../compare/assets/icons/icon-nav-overview.svg";
import OverviewSelected from "../../../compare/assets/icons/icon-nav-overview-select.svg";
import Compare from "../../../compare/assets/icons/icon-nav-compare-noselect.svg";
import CompareSelected from "../../../compare/assets/icons/icon-nav-compare.svg";
import LifeSidebar from "../../../compare/assets/icons/icon-nav-life.svg";
import LifeSidebarSelected from "../../../compare/assets/icons/icon-nav-life-select.svg";
import HealthSidebar from "../../../compare/assets/icons/icon-nav-health.svg";
import HealthSidebarSelected from "../../../compare/assets/icons/icon-nav-health-select.svg";
import TraumaSidebar from "../../../compare/assets/icons/icon-nav-trauma.svg";
import TraumaSidebarSelected from "../../../compare/assets/icons/icon-nav-trauma-select.svg";
import IncomeSidebar from "../../../compare/assets/icons/icon-nav-income.svg";
import IncomeSidebarSelected from "../../../compare/assets/icons/icon-nav-income-select.svg";
import MortgageSidebar from "../../../compare/assets/icons/icon-nav-mortgage.svg";
import MortgageSidebarSelected from "../../../compare/assets/icons/icon-nav-mortgage-select.svg";
import LogoMain from "../../../compare/assets/icons/logo-lifedirect-main.svg";
import LogoMainMobile from "../../../compare/assets/icons/logo-lifedirect-main-mobile.svg";
import DoneTick from "../../../compare/assets/icons/icon-tick-done.svg";
import ApplyActive from "../../../compare/assets/icons/icon-nav-apply.svg";
import ApplyWhite from "../../../compare/assets/icons/icon-nav-apply-white.svg";
import CloseSidebar from "../../../compare/assets/icons/icon-x-hamburger.svg";
import NavAccordion from "../../../compare/assets/icons/icon-nav-arrow.svg";
import NavAccordionBlue from "../../../compare/assets/icons/icon-nav-arrow-blue.svg";
import MyLifeDirectLock from "../../../compare/assets/icons/icon-lock-mylifedirect.svg";

// quotes
import Share from "../../../compare/assets/icons/icon-share.svg";
import Sort from "../../../compare/assets/icons/icon-sort.svg";
import SaveTick from "../../../compare/assets/icons/icon-saved-tick.svg";
import CantFindCamp from "../../../compare/assets/icons/cant-find-results.svg";
import MultiBenefitDiscount from "../../../compare/assets/icons/icon-multi-benefit-discount.svg";
import EditCog from "../../../compare/assets/icons/icon-edit-settings.svg";
import EditCogPencil from "../../../compare/assets/icons/icon-edit-settings-pencil.svg";
import ErrorQuotes from "../../../compare/assets/icons/error-cant-find-quotes.svg";
import ErrorSelectProducts from "../../../compare/assets/icons/error-select-products.svg";

//Slider
import SliderPlus from "../../../compare/assets/icons/icon-slider-plus.svg";
import SliderMinus from "../../../compare/assets/icons/icon-slider-minus.svg";

// apply
import ApplyEmpty from "../../../compare/assets/icons/illustration-apply-empty.svg";
import Cashback from "../../../compare/assets/icons/icon-cashback-apply.svg";
import CashbackGold from "../../../compare/assets/icons/icon-cashback.svg";
import ToolTipApplyArrowLeft from "../../../compare/assets/icons/tooltip-whats-next-arrow-left.svg";
import ToolTipApplyArrowDown from "../../../compare/assets/icons/tooltip-whats-next-arrow-down.svg";

// premium structure
import PremiumStructureGraph from "../../../compare/assets/icons/icon-premium-structure-graph.svg";
import PremiumStructureStepped from "../../../compare/assets/icons/icon-premium-structure-stepped.svg";
import PremiumStructureLevel from "../../../compare/assets/icons/icon-premium-structure-level.svg";
import SteppedCoverGraph from "../../../compare/assets/icons/icon-stepped-graph.svg";
import LevelCoverGraph from "../../../compare/assets/icons/icon-level-graph.svg";

// modals
import CloseModal from "../../../compare/assets/icons/icon-close-x-green.svg";
// modal - premium
import SteppedCover from "../../../compare/assets/icons/icon-stepped.svg";
import LevelCover from "../../../compare/assets/icons/icon-level.svg";

// Logos
import QPRLogo from "../../../compare/assets/logo-qpr.svg";
import TrademeKevWhite from "../../../compare/assets/icons/logo-tm-kev-white.svg";
import TrademeKev from "../../../compare/assets/icons/logo-tm-kev.svg";
// Ratings
import YellowStar from "../../../compare/assets/icons/icon-yellow-star.svg";
import YellowStarHalf from "../../../compare/assets/icons/icon-yellow-star-half.svg";
import GreenStar from "../../../compare/assets/icons/icon-green-star.svg";
import GreenStarHalf from "../../../compare/assets/icons/icon-green-star-half.svg";

// other
import Chevron from "../../../compare/assets/icons/icon-chevron-left.svg";
import ChevronBack from "../../../compare/assets/icons/icon-chevron-back.svg";
import ChevronBackLarge from "../../../compare/assets/icons/icon-back-chevron.svg";
import ChevronRight from "../../../compare/assets/icons/icon-chevron-right.svg";
import ExternalLink from "../../../compare/assets/icons/icon-external-link.svg";
import ExternalLinkWhite from "../../../compare/assets/icons/icon-external-link-white.svg";
import ExternalLinkDark from "../../../compare/assets/icons/icon-external-link-dark.svg";
import Phone from "../../../compare/assets/icons/icon-phone.svg";
import OpenHours from "../../../compare/assets/icons/icon-open-hours.svg";
import Email from "../../../compare/assets/icons/icon-email.svg";
import Address from "../../../compare/assets/icons/icon-address.svg";
import ChevronWhite from "../../../compare/assets/icons/icon-next-chevron-white.svg";
import HowMuchDoOthers from "../../../compare/assets/icons/illustration-how-much-do-others.svg";
import ArrowGetQuotes from "../../../../../images/landing/icon-arrow-get-quotes-btn.svg";
import BundleDiscount from "../../../compare/assets/icons/icon-bundle.svg";
import Secure from "../../../compare/assets/icons/icon-secure-green.svg";
import SecureCircle from "../../../../../images/svg/icons/icon-promo-secure.svg";
import Spinner from "../../../compare/assets/icons/spinner-loader.svg";
import Info from "../../../../../images/landing/icon-info-green.svg";

// Acknowledgement/Thanks
import OopsThanks from "../../../compare/assets/icons/oops-modal.svg";
import DogThanks from "../../../compare/assets/icons/thanks-modal.svg";

// legacy
import LegacyEmail from "../../../compare/assets/icons/legacy/icon-email--grey.svg";
import LegacyMobile from "../../../compare/assets/icons/legacy/icon-mobile--grey.svg";
import LegacyClose from "../../../compare/assets/icons/legacy/icon-lightwindow-close.svg";
import LegacyTelephone from "../../../compare/assets/icons/legacy/icon-telephone.svg";

// bunnings view
import AIALogo from "../../../../../images/svg/insurers/logo-aia.svg";
import ChubbLifeLogo from "../../../../../images/svg/insurers/logo-chubb.svg";
import AsteronLogo from "../../../../../images/svg/insurers/logo-asteron.svg";
import FidelityLogo from "../../../../../images/svg/insurers/logo-fidelity.svg";

// Cart
import ShoppingCart from "../../../../../images/cart/icon-cart.svg";
import TrashCan from "../../../compare/assets/icons/icon-trash.svg";

// settings app
import SettingsCog from "../../../compare/assets/icons/icon-cover-settings.svg";
import SettingsPeople from "../../../compare/assets/icons/icon-who-needs-cover.svg";
import PlusPersonIcon from "../../../compare/assets/icons/icon-add-a-partner.svg";
import PersonIcon from "../../../compare/assets/icons/icon-edit-who-needs-cover.svg";
import PeopleCheckup from "../../../compare/assets/icons/icon-not-sure-checkup.svg";

// elements
import DropdownArrow from "../../../compare/assets/icons/icon-drop-down-arrow.svg";

// promote DAP icon
import PromoteDapIcon from "../../../digital-advice/assets/images/get-advice-mini-illustration.svg";

export const IconSet = {
    ApplyEmpty,
    ChooseHealth,
    ChooseLife,
    ChooseTrauma,
    ChooseIncome,
    ChooseMortgage,
    ChooseProductHelp,
    LogoMain,
    LogoMainMobile,
    YouAndFamily,
    AddAdult,
    AddChildren,
    Callback,
    Phone,
    Remove,
    Settings,
    Add,
    AlertInfo,
    AlertPink,
    AlertError,
    Help,
    AiaVitality,
    GreenTick,
    WhiteTick,
    RedCross,
    GreyCross,
    PolicyPlaceholder,
    DoneTick,
    TrademeKev,
    ApplyActive,
    ApplyWhite,
    Overview,
    LifeSidebar,
    HealthSidebar,
    TraumaSidebar,
    IncomeSidebar,
    MortgageSidebar,
    OverviewSelected,
    LifeSidebarSelected,
    HealthSidebarSelected,
    TraumaSidebarSelected,
    IncomeSidebarSelected,
    MortgageSidebarSelected,
    MyLifeDirectLock,
    CloseSidebar,
    LegacyEmail,
    LegacyMobile,
    LegacyClose,
    LegacyTelephone,
    Calculator,
    ArrowAccordion,
    AccordionPlus,
    AccordionMinus,
    SliderPlus,
    SliderMinus,
    Share,
    SaveTick,
    PremiumStructureGraph,
    PremiumStructureStepped,
    PremiumStructureLevel,
    SteppedCoverGraph,
    LevelCoverGraph,
    CloseModal,
    QPRLogo,
    Chevron,
    ExternalLink,
    ExternalLinkWhite,
    ExternalLinkDark,
    HelpPhone,
    Address,
    Email,
    OpenHours,
    Cashback,
    CashbackGold,
    SteppedCover,
    LevelCover,
    DogThanks,
    OopsThanks,
    ContactUs,
    CantFindCamp,
    ErrorQuotes,
    ErrorSelectProducts,
    Sort,
    ToolTipApplyArrowLeft,
    ToolTipApplyArrowDown,
    YellowStar,
    YellowStarHalf,
    GreenStar,
    GreenStarHalf,
    AIALogo,
    ChubbLifeLogo,
    AsteronLogo,
    FidelityLogo,
    MultiBenefitDiscount,
    CircleTick,
    Compare,
    CompareSelected,
    CompareAlert,
    NavAccordion,
    NavAccordionBlue,
    ShoppingCart,
    ChevronBack,
    ChevronWhite,
    TrashCan,
    TrademeKevWhite,
    SettingsCog,
    SettingsPeople,
    ChooseCover,
    EditCog,
    PersonIcon,
    HowMuchDoOthers,
    ArrowGetQuotes,
    EditCogPencil,
    BundleDiscount,
    DropdownArrow,
    PeopleCheckup,
    ChevronBackLarge,
    ChevronRight,
    GreenCircle,
    PromoteDapIcon,
    PlusPersonIcon,
    Secure,
    SecureCircle,
    Spinner,
    Info,
    GreenTickNew,
    Pencil
};

export type IconSetIds = keyof typeof IconSet;
